import {useRouteMatch} from "react-router-dom";
import {Container, Row, Col} from "react-bootstrap";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Swiper, SwiperSlide} from 'swiper/react';
import {
    BASE_URL, FOOD_PACKAGE_POST, PUBLIC_URL_SERVER, IMG_SLIDER_FOOD_PACKAGE_URL_SERVER
} from "../../../../apis";
import useWindowDimensions from "../../../../styles/lib/getWindowSize";
import _ from "lodash";
import axios from "axios";
import qs from "querystring";
import {actionGetFoodPackageDetails} from "../../../../redux/actions/pages/foodPackage";


const MyPack = () => {
    const match = useRouteMatch();
    const dispatch = useDispatch();
    const {token} = useSelector(state => state.user);
    // const history = useHistory();


    const {images: banners, title, calory, count, duration, description, ingredients_list, instructions} = useSelector(state => state.foodPackage);

    const {width} = useWindowDimensions();

    useEffect(() => {
        apiGetFoodPackageDetails();
        // eslint-disable-next-line
    }, MyPack);


    const apiGetFoodPackageDetails = () => {
        axios({
            method: 'post',
            url: BASE_URL + FOOD_PACKAGE_POST,
            data: qs.stringify({
                food_package : match.params.id,
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            if(response.data.status === "ok") 
                dispatch(actionGetFoodPackageDetails(response.data.package));
        });
    };

    


    return (
        <div className='page-food-pack'>
            <div className='food-pack-main' style={{marginTop: '55px'}}>
                <div>
                    {width > 576 &&
                    <div>
                        {banners.length === 1 ?
                            <LazyLoadImage
                                alt={banners[0].big}
                                src={PUBLIC_URL_SERVER + IMG_SLIDER_FOOD_PACKAGE_URL_SERVER + banners[0].big}
                                width={'100%'}
                            />
                            :
                            <Swiper slidesPerView={1} pagination={{clickable: true}} autoplay={{delay: 3500, disableOnInteraction: false}} loop={true}>
                                {_.map(banners, (banner, index) => (
                                    <SwiperSlide key={index}>
                                        <LazyLoadImage
                                            alt={banner.big}
                                            src={PUBLIC_URL_SERVER + IMG_SLIDER_FOOD_PACKAGE_URL_SERVER + banner.big}
                                            width={'100%'}
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        }
                    </div>
                    }
                </div>

                <Container>
                    <div>
                        {width < 576 &&
                        <div>
                            {banners.length === 1 ?
                                <LazyLoadImage
                                    alt={banners[0].small}
                                    src={PUBLIC_URL_SERVER + IMG_SLIDER_FOOD_PACKAGE_URL_SERVER + banners[0].small}
                                    width={'100%'}
                                />
                                :
                                <Swiper slidesPerView={1} pagination={{clickable: true}} autoplay={{delay: 3500, disableOnInteraction: false}} loop={true}>
                                    {_.map(banners,(banner, index) => (
                                        <SwiperSlide key={index}>
                                            <LazyLoadImage
                                                alt={banner.small}
                                                src={PUBLIC_URL_SERVER + IMG_SLIDER_FOOD_PACKAGE_URL_SERVER + banner.small}
                                                width={'100%'}
                                            />
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            }
                        </div>
                        }
                    </div>



                    <div className={'text-center'}>
                        <div className={'h3 mt-4'}>
                            <span>{title}</span>
                        </div>

                        <div className="row justify-content-center mt-4">
                            <div className="col-3 col-md-2">
                                <span className="info-head-light">کالری</span>
                                <br />
                                <span className="info-content-dark">{calory}</span>
                            </div>
                            <div className="col-3 col-md-2 border-right">
                                <span className="info-head-light">تعداد</span>
                                <br />
                                <span className="info-content-dark">{count}</span>
                            </div>
                            <div className="col-3 col-md-2 p-0 border-right">
                                <span className="info-head-light">زمان</span>
                                <br />
                                <span className="info-content-dark">{duration} دقیقه</span>
                            </div>
                        </div>

                        <Container>
                            <div><div>
                                <div className="row text-justify mt-4">
                                    <Container>
                                        {description}
                                    </Container>
                                </div>
                            </div></div>
                        </Container>

                    </div>




                    <div className={'base-box-page-more-products'}>
                        <React.Fragment>
                            

                            <div className={'box-page-more-products'} style={{marginTop: '40px'}}>
                                <div className={'box-header-page-more-products'}>
                                    <h5 className={'txt-title-header-page-more-products'}>لیست مواد مورد نیاز</h5>
                                </div>
                                <div className={'box-list-items-page-more-products'}>
                                    <Row>
                                        <Col >
                                            {ingredients_list !== null &&  ingredients_list !== undefined && ingredients_list.length > 0 ?
                                                ingredients_list.split('\n').map((line, i) => (
                                                    <span key={i}>
                                                        {line}
                                                        <br/>
                                                    </span>
                                                ))
                                            :''}
                                        </Col>
                                    </Row>
                                </div>
                            </div>


                            <div className={'box-page-more-products'} style={{marginTop: '40px'}}>
                                <div className={'box-header-page-more-products'}>
                                    <h5 className={'txt-title-header-page-more-products'}>دستور پخت</h5>
                                </div>
                                <div className={'box-list-items-page-more-products'}>
                                    <Row>
                                        <Col  >
                                            {instructions !== null &&  instructions !== undefined && instructions.length > 0 ?
                                                instructions.split('\n').map((line, i) => (
                                                    <span key={i}>
                                                        {line}
                                                        <br/>
                                                    </span>
                                                ))
                                            :''}
                                        </Col>
                                    </Row>
                                </div>
                            </div>

                        </React.Fragment>
                    </div>



                </Container>

            </div>

            
            

        </div>
    );
}

export default MyPack;
